import axios from 'axios';

const KciApi = {
  getPartners: () => {
    //
  },
  updateTransaction: (ptc: string, value: string | boolean | Date) => {
    const data = new FormData();
    data.append('ptc', ptc);
    data.append('industry', typeof value === 'string' ? value : '');
    return axios.post('/buy/ajax/update_transaction_scheme.html', data);
  },
  getFormQuestions: (ptc: string, value: string | boolean | Date, id: string) => {
    const data = new FormData();
    data.append('ptc', ptc);
    data.append('option_id', typeof value === 'string' ? value.split('-')[1] : '');
    data.append('question_id', id.replace(window.kbSchema.controlPrefix, ''));
    const isSuffix = id.split('_').filter((x) => Number(x)).length > 1;
    if (isSuffix) {
      data.append('question_suffix', `_${id.split('_')[id.split('_').length - 1]}`);
    }
    return axios.post('/account_pages/ajax/get_form_question_options.html', data);
  },
  updateTransactionScheme: () => {
    //
  },
  getFurtherQuestions: () => {
    //
  },
  getQuote: () => {
    // /
  },
  getPriceUpdate: (type: string) => axios.post(`${window.kbSchema.data.get_price.url}&json=1&popt=${type === 'creditcard' ? 'lump-sum' : 'instalments'}`),
  getPaymentDetails: () => {
    //
  },
};

export default KciApi;
